import { createRouter, createWebHashHistory } from "vue-router";
const routes = [
  {
    name: "ErrorPage",
    path: "/error",
    component: () => import("@/pages/ErrorPage"),
  },
  {
    name: "401Page",
    path: "/401", // sabit path, token gibi davranmaz
    component: () => import("@/pages/401Page"),
  },
  {
    name: "FormPage",
    path: "/form_page",
    component: () => import("@/pages/FormRecordPage"),
  },
  {
    name: "Home",
    path: "/:token",
    component: () => import("@/pages/RoutePage"),
  },
  {
    name: "NotFound",
    path: "/:catchAll(.*)",
    component: () => import("@/pages/401Page"),
  },
];
const router = createRouter({
  routes,
  history: createWebHashHistory(),
});
router.beforeEach(async (to, _, next) => {
  next();
});
export default router;
